export const AzureB2CConstants = {
    ErrorRedirectResetPasswordFlow:"AADB2C90118",
}